import styled from "styled-components";

import WhyNexusElement from "../../components/molecules/WhyNexusElement/WhyNexusElement";
import { theme } from "../../theme";

const Wrapper = styled.section`
  div:nth-of-type(even) {
    background-color: ${theme.backgroundColors.primary};
  }
`;

const WhyNexus = () => {
  return (
    <Wrapper id="whynexus">
      <WhyNexusElement />
      <WhyNexusElement />
      <WhyNexusElement />
    </Wrapper>
  );
};
export default WhyNexus;
